import {useCallback, useEffect} from 'react'
import {DropzoneOptions} from 'react-dropzone'

type AdminFilePaste = {
  onDropAccepted: DropzoneOptions['onDrop']
  maxFiles: number
  currentFilesCount: number
  isEnabled: boolean
}

export const useAdminFilePaste = ({
  onDropAccepted,
  maxFiles,
  currentFilesCount,
  isEnabled,
}: AdminFilePaste) => {
  const onPaste = useCallback(
    (event: ClipboardEvent) => {
      const item = event.clipboardData?.items[0]
      if (item && item.type?.indexOf('image') === 0) {
        const blob = item.getAsFile()
        if (currentFilesCount < maxFiles && blob && onDropAccepted) {
          onDropAccepted([blob], [], event)
        }
      }
    },
    [currentFilesCount, maxFiles, onDropAccepted],
  )

  useEffect(() => {
    if (isEnabled) {
      document.addEventListener('paste', onPaste)
    } else {
      document.removeEventListener('paste', onPaste)
    }
    return () => document.removeEventListener('paste', onPaste)
  }, [onPaste, isEnabled])
}
